type DeckHeatmapWeightedLocation = {
    location: google.maps.LatLng | null | undefined;
    weight: number;
};

export type DeckHeatmapInput =
    | DeckHeatmapWeightedLocation
    | google.maps.LatLng
    | google.maps.LatLngLiteral;

export type HeatmapPoint = { position: [number, number]; weight: number };

export const toArray = (
    data: DeckHeatmapInput[] | google.maps.MVCArray<DeckHeatmapInput>,
): DeckHeatmapInput[] => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof (data as google.maps.MVCArray<DeckHeatmapInput>).getArray === 'function') {
        return (data as google.maps.MVCArray<DeckHeatmapInput>).getArray();
    }
    return [];
};

export const extractPoint = (entry: DeckHeatmapInput): HeatmapPoint | null => {
    if (entry == null) return null;
    if (typeof google !== 'undefined' && entry instanceof google.maps.LatLng) {
        return { position: [entry.lng(), entry.lat()], weight: 1 };
    }
    const weighted = entry as DeckHeatmapWeightedLocation;
    if (
        weighted.location &&
        typeof google !== 'undefined' &&
        weighted.location instanceof google.maps.LatLng
    ) {
        const w = Number.isFinite(weighted.weight) ? Math.max(0, weighted.weight) : 1;
        return { position: [weighted.location.lng(), weighted.location.lat()], weight: w };
    }
    const literal = entry as google.maps.LatLngLiteral;
    if (
        literal &&
        typeof literal.lat === 'number' &&
        typeof literal.lng === 'number' &&
        Number.isFinite(literal.lat) &&
        Number.isFinite(literal.lng)
    ) {
        return { position: [literal.lng, literal.lat], weight: 1 };
    }
    return null;
};

/** The points deck.gl draws: [lng, lat] with a positive weight; anything unusable is dropped. */
export const heatmapPoints = (
    data: DeckHeatmapInput[] | google.maps.MVCArray<DeckHeatmapInput>,
): HeatmapPoint[] =>
    toArray(data)
        .map(extractPoint)
        .filter((p): p is HeatmapPoint => p != null && p.weight > 0);
